/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from "@msdyn365-commerce/core";
import axios from "axios";
import querystring from 'querystring';
// const querystring = require('querystring');

/**
 * GetAtpToken Input Action
 */
// interface IToken {
//   token_type: string;
//   expires_in: string;
//   ext_expires_in: string;
//   expires_on: string;
//   not_before: string;
//   resource: string;
//   access_token: string;
// }

export class GetTokenInput implements Msdyn365.IActionInput {
  // TODO: Construct the input needed to run the action
  constructor() { }

  // TODO: Determine if the results of this get action should cache the results and if so provide
  // a cache object type and an appropriate cache key
  public getCacheKey = () => `GetSharePointToken`;
  public getCacheObjectType = () => "GetSharePointToken";
  public dataCacheType = (): Msdyn365.CacheType => "none";
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
  args: Msdyn365.ICreateActionContext
): Msdyn365.IActionInput => {
  return new GetTokenInput();
};

const fetchResourceAndTenant = async (domain: any, siteName: any): Promise<{ tenatId: string , resource: string }> => {
  try {
    await axios(
      `https://${domain}.sharepoint.com/sites/${siteName}/_vti_bin/client.svc/`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer`,
        }
      }
    );
  } catch (error) {
    // @ts-ignore
    const response = error?.response?.headers?.["www-authenticate"];
    const regex = /realm="([^"]*)".*client_id="([^"]*)"/;
    const matches = response.match(regex);
    const tenatId = matches[1];
    const resource = matches[2];
    return { tenatId, resource };
  }
  return { tenatId: '', resource: '' }; 
};

const fetchToken = async (tenatId: string | undefined, resource: string | undefined, clientId: string, secret: string, domain: string): Promise<string | undefined> => {
  if (tenatId && resource) {


    const url = `https://accounts.accesscontrol.windows.net/${tenatId}/tokens/OAuth/2`;
    const headers = {
      Authorization: 'Bearer',
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    const data = {
      grant_type: 'client_credentials',
      client_id: `${clientId}@${tenatId}`,
      client_secret: `${secret}`,
      resource: `${resource}/${domain}.sharepoint.com@${tenatId}`,
    };

    const requestBody = querystring.stringify(data);

    return axios.post(url, requestBody, { headers })
      .then((response) => {
        return response?.data?.access_token
      })
      .catch((error) => {
        console.error('Error getting token:', error);
      });
  }
  return undefined;
};


async function getToken(ctx: Msdyn365.IRequestContext) {
  let token: string | undefined;

  /**
   * we need to create sharepoint site first 
   * and then needs to generate client id and it's secret and give all permisions
   * Register Add-In using the AppRegNew form
   * try to get token SSR
   */
  if (process.env.CURRENT_ENVIRONMENT === "node") {
    // const siteName = "SZF";
    // const domain = "visionetsys";
    // const secret = "gWq9FCsXH2VA06zh28N/2L9SeVw1qJTe1pwxTZHe/VU=";
    // const clientId = '24c715c7-8a12-4dd6-80a6-902efba3667b';

    // const siteName = "SZFEcommerce";
    // const domain = "zayedfestival";
    // const secret = "j/hcvlz0kWhvlVHhlDbGwSN/VdD855DPqeFN3CO6tNk=";
    // const clientId = '6a1e8d91-af56-4d02-a7d1-b601df3cbb71';

    const siteName = "SZF-Ecommerce";
    const domain = "zayedfestival";
    const secret = "UFvBGJ3TdJYQ8DmIlGEe9nxNmQJYZyw4LPsfTUYT4y4=";
    const clientId = '95ba8411-3d62-4e2d-95c9-dcf08f6473f1';

    const { tenatId, resource } = await fetchResourceAndTenant(domain, siteName);
    token = await fetchToken(tenatId, resource, clientId, secret, domain);
  }

  return { token: token };
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getTokenAction(
  input: GetTokenInput,
  ctx: Msdyn365.IActionContext
): Promise<any> {
  const response = await getToken(ctx.requestContext);
  return response;
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<string>>getTokenAction,
  // TODO: Give your data action a unique id
  id: "GetToken",
  input: createInput,
  // TODO: Uncomment the below line if this is a meant to be a batched data action
  // isBatched: true
});
